<template>
  <div class="autocomplete-textfield">
    <v-text-field :label="label" required v-bind:value="value" ref="field" :rules="mandatory" :readonly="readonly"
      @input="onChange" @keyup.down="onArrowDown" @keyup.up="onArrowUp" @keyup.enter="onEnter"
      v-on:focus="onFocus" v-on:blur="onBlur">
    </v-text-field>
    <div id="autocomplete-results" v-show="isOpen" class="autocomplete-results">
      <div v-for="(result, i) in results" :key="i" @click="setResult(result)" v-touch:tap="tapHandler(i)"
        class="autocomplete-result" :class="{ 'is-active': i === arrowCounter, 'accent': i === arrowCounter }"
        >
        {{ result }}
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'underscore'
export default {
  props: ['value', 'label', 'suggestions', 'readonly'],
  data () {
    return {
      isOpen: false,
      arrowCounter: 0,
      results: [],
      mandatory: [
        v => !!v || 'Obavezno polje'
      ]
    }
  },
  methods: {
    onChange (value) {
      // Let's warn the parent that a change was made
      this.$emit('input', value)
      this.showSuggestions()
    },
    showSuggestions () {
      this.$nextTick(() => this.filterResults())
      this.isOpen = true
    },
    hideSuggestions () {
      this.isOpen = false
      this.arrowCounter = -1
    },
    filterResults: _.debounce(function () {
      this.results.length = 0
      for (let i in this.suggestions) {
        let suggestion = this.suggestions[i]
        // first uncapitalize all the things
        if (!this.value || suggestion.toLowerCase().indexOf(this.value.toLowerCase()) > -1) {
          this.results.push(suggestion)
        }
        if (this.results.length === 4) {
          break
        }
      }
      if (this.results.length === 0) {
        this.$nextTick(() => this.$forceUpdate())
      }
    }, 300),
    setResult (result) {
      this.isOpen = false
      this.$emit('input', result + ' ')
      setTimeout(() => this.$refs.field.focus(), 5)
    },
    tapHandler (i) {
      return (event) => {
        this.setResult(this.results[i])
      }
    },
    onArrowDown (evt) {
      if (!this.isOpen) {
        this.showSuggestions()
      } else if (this.arrowCounter < this.results.length - 1) {
        this.arrowCounter = this.arrowCounter + 1
      }
    },
    onArrowUp () {
      if (!this.isOpen) {
        this.showSuggestions()
      } else if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1
      }
    },
    onEnter () {
      if (this.isOpen && this.results.length > 0 && this.arrowCounter !== -1) {
        this.$emit('input', this.results[this.arrowCounter] + ' ')
        this.hideSuggestions()
      }
    },
    onFocus () {
      this.showSuggestions()
    },
    onBlur () {
      setTimeout(this.hideSuggestions, 100)
    },
    handleClickOutside (evt) {
      if (!this.$el.contains(evt.target)) {
        this.hideSuggestions()
      }
    }
  },
  watch: {
    suggestions: function (val, oldValue) {
      // actually compare them
      if (val.length !== oldValue.length) {
        this.results = val
      }
    }
  },
  mounted () {
    document.addEventListener('click', this.handleClickOutside)
  },
  destroyed () {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>

<style scoped>

.autocomplete-textfield {
  overflow: visible;
  position: relative;
  z-index: 1;
}

.autocomplete-results {
  position: absolute;
  padding: 0;
  margin: -26px 0 0;
  height: 160px;
  overflow: auto;
  width: 100%;
}

.autocomplete-result {
  border: 1px solid #eeeeee;
  list-style: none;
  text-align: left;
  padding: 4px 2px;
  cursor: pointer;
  background-color: #fafafa;
  height: 40px;
  font-size: 16px;
}

</style>
